<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{PageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Provider Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="categoryName">Category Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="categoryName" type="text" class="form-control" id="categoryName" placeholder="Category Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{categoryNameError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="categories">Parent Category :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="categoryId"
                                              @change="changedValue"
                                              @input="changedCategoryFor()"
                                              name="categoryId"
                                              id="categoryId"
                                              label="text"
                                              :filterable="false"
                                              :options="categoryArr"
                                              @search="onSearchCategory"
                                              placeholder="Select Category">
                                        <template slot="no-options">
                                            Search Parent Category...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div v-if='isParentSet === false' class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Category For :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="roleId"
                                              @change="changedValue"
                                              @input="changedValueSearchFor()"
                                              name="roleId"
                                              id="roleId"
                                              label="text"
                                              :filterable="false"
                                              :options="roleArr"
                                              @search="onSearchRole"
                                              placeholder="Select Category For">
                                        <template slot="no-options">
                                            Search User Role...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{roleForError}}</font>
                                </div>
                            </div>
                            <div v-if='isParentSet === false' class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select multiple
                                              v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <template v-if="categoryType == 'gallery'">
                                <div class="col-12 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" for="categoryDescription">Description :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <textarea rows="3" v-model="categoryDescription" class="form-control" id="categoryDescription" placeholder="Category Description"></textarea>
                                    </div>
                                </div>
                            </template>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addCategoryBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="saveCategory()">
                                    <input id="addAndContinueCategory" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="saveCategory(flag='Save and Continue')">
                                    <input id="CancelCategory" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    export default {
        name: 'AddBenefits',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                PageTitle: '',
                isParentSet: false,
                categoryType: '',
                categoryName: '',
                categoryNameError: '',
                categoryDescription: '',
                locationId: '',
                locationError: '',
                locationArr: [],
                roleId: '',
                roleForError: '',
                roleArr: [],
                categoryId: '',
                categoryArr: [],
            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");
            self.categoryType = segments[3];
            self.PageTitle = 'Add Category  (' + self.formatString(self.categoryType) + ')';
            self.loadLocationsAdd();
            self.loadRoleFirst();
            self.loadCategoryFirst();
            if (segments[2] == 'updatecategory') {
                self.PageTitle = 'Edit Category (' + self.formatString(self.categoryType) + ')';
                if (segments[4]) {
                    self.loadBenefitProvider();
                    $("#addAndContinueCategory").hide();
                    $("#addCategoryBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            } else {
                self.$nextTick(function () {
                    self.hideLoader();
                });
            }
            $("#categoryName").on('keyup', function () {
                self.categoryNameError = '';
            });
            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#roleId").on('keyup', function () {
                self.roleForError = '';
            });
            $("#categoryId").on('keyup', function () {
                self.locationError = '';
                self.roleForError = '';
            });
            $("#alertError").hide();
        },
        watch: {
            categoryId: function (categoryId) {
                self.isParentSet = (self.categoryId === null || self.categoryId == '') ? false : true;
                console.log(self.isParentSet);
            }
        },
        methods: {
            /*saveCategory() {
             self.$router.push('/backend/addbenefits/' + self.categoryType + '/' + 0);
             },*/
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listcategory/' + self.categoryType);
            },

            checkForm: function () {
                var checked = true;
                self.locationError = "";
//                self.categoryName = "";
                if (!self.categoryName) {
                    self.categoryNameError = "Category Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                var categoryId = (self.categoryId === null || self.categoryId == '') ? "" : self.categoryId.value;
                if (categoryId == '') {
                    if (self.locationId.length === 0) {
                        self.locationError = "State Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (!self.roleId) {
                        self.roleForError = "Category For Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            saveCategory(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var categoryId = (self.categoryId === null || self.categoryId == '') ? "" : self.categoryId.value;
                    var roleId = (self.roleId === null || self.roleId == '') ? "" : self.roleId.value;
                    var locationId = (self.locationId === null || self.locationId == '') ? "" : self.locationId;
                    if (categoryId != '') {
                        roleId = locationId = '';
                    }
                    if (locationId != '') {
                        locationId = '';
                        for (var i = 0; i < self.locationId.length; i++) {
                            locationId += (self.locationId[i].value) + ',';
                        }
                        locationId = locationId.replace(/,\s*$/, "");
                    }
                    if (segments[2] == 'updatecategory') {
                        if (segments[4]) {
                            var data = {
                                type: self.categoryType,
                                name: self.categoryName,
                                category_description: self.categoryDescription,
                                parent_category: categoryId,
                                role_id: roleId,
                                location_id: locationId,
                                id: segments[4],
                            };
                            $("#addCategoryBtn").val("Updating ...");
                            $("#addCategoryBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelCategory").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueCategory").val("Saving ...");
                                $("#addAndContinueCategory").prop("disabled", true);
                                $("#addCategoryBtn").prop("disabled", true);
                                $("#CancelCategory").prop("disabled", true);
                            } else {
                                $("#addCategoryBtn").val("Saving ...");
                                $("#addCategoryBtn").prop("disabled", true);
                                $("#addAndContinueCategory").prop("disabled", true);
                                $("#CancelCategory").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            type: self.categoryType,
                            name: self.categoryName,
                            category_description: self.categoryDescription,
                            parent_category: categoryId,
                            role_id: roleId,
                            location_id: locationId,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueCategory").val("Saving ...");
                            $("#addAndContinueCategory").prop("disabled", true);
                            $("#addCategoryBtn").prop("disabled", true);
                            $("#CancelCategory").prop("disabled", true);
                        } else {
                            $("#addCategoryBtn").val("Saving ...");
                            $("#addCategoryBtn").prop("disabled", true);
                            $("#addAndContinueCategory").prop("disabled", true);
                            $("#CancelCategory").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatecategory", data, config)
                            .then(function (response) {
//                        console.log(response.data.content);
                                if (segments[2] == 'updatecategory') {
                                    if (segments[4]) {
                                        //console.log(segments[4]);
                                        $("#addCategoryBtn").val("Update");
                                        $("#addCategoryBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCategory").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCategory").val("Save and Continue");
                                            $("#addAndContinueCategory").prop("disabled", false);
                                            $("#addCategoryBtn").prop("disabled", false);
                                            $("#CancelCategory").prop("disabled", false);
                                        } else {
                                            $("#addCategoryBtn").val("Save");
                                            $("#addCategoryBtn").prop("disabled", false);
                                            $("#addAndContinueCategory").prop("disabled", false);
                                            $("#CancelCategory").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCategory").val("Save and Continue");
                                        $("#addAndContinueCategory").prop("disabled", false);
                                        $("#addCategoryBtn").prop("disabled", false);
                                        $("#CancelCategory").prop("disabled", false);
                                    } else {
                                        $("#addCategoryBtn").val("Save");
                                        $("#addCategoryBtn").prop("disabled", false);
                                        $("#addAndContinueCategory").prop("disabled", false);
                                        $("#CancelCategory").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.categoryName = '';
                                        self.categoryDescription = '';
                                        self.categoryId = '';
                                        self.roleId = '';
                                        self.locationId = '';
                                        self.loadLocationsAdd();
                                        self.loadRoleFirst();
                                        self.loadCategoryFirst();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatecategory') {
                                    if (segments[4]) {
                                        $("#addCategoryBtn").val("Update");
                                        $("#addCategoryBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCategory").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCategory").prop("disabled", false);
                                            $("#addAndContinueCategory").val("Save and Continue");
                                            $("#addCategoryBtn").prop("disabled", false);
                                            $("#CancelCategory").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.categoryName = '';
                                            self.categoryDescription = '';
                                            self.categoryId = '';
                                            self.roleId = '';
                                            self.locationId = '';
                                            self.loadLocationsAdd();
                                            self.loadRoleFirst();
                                            self.loadCategoryFirst();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addCategoryBtn").val("Save");
                                            $("#addCategoryBtn").prop("disabled", false);
                                            $("#addAndContinueCategory").prop("disabled", true);
                                            $("#CancelCategory").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCategory").prop("disabled", false);
                                        $("#addAndContinueCategory").val("Save and Continue");
                                        $("#addCategoryBtn").prop("disabled", false);
                                        $("#CancelCategory").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.categoryName = '';
                                        self.categoryDescription = '';
                                        self.categoryId = '';
                                        self.roleId = '';
                                        self.locationId = '';
                                        self.loadLocationsAdd();
                                        self.loadRoleFirst();
                                        self.loadCategoryFirst();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addCategoryBtn").val("Save");
                                        $("#addCategoryBtn").prop("disabled", false);
                                        $("#addAndContinueCategory").prop("disabled", true);
                                        $("#CancelCategory").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },

            loadBenefitProvider: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'id': segments[4],
                    }

                };
                self.showLoader();
                HTTP.get("getcategoryedit", config)
                        .then(function (response) {
                            self.categoryName = response.data.content[0].category_name;
                            self.categoryDescription = response.data.content[0].description;
                            if (response.data.content[0].parent_id != null) {
                                self.categoryId = {value: response.data.content[0].parent_id, text: response.data.content[0].parent_name};
                            } else {
                                self.categoryId = '';
                            }
                            if (response.data.content[0].role_id != null) {
                                self.roleId = {value: response.data.content[0].role_id, text: response.data.content[0].role_name};
                            } else {
                                self.roleId = '';
                            }
                            if (response.data.content[0].location_id != null) {
                                self.locationId = [];
                                for (var i = 0; i < response.data.content[0].location.length; i++) {
                                    self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                                }
                                /*self.locationId = {value: response.data.content[0].location_id, text: response.data.content[0].location_name};*/
                            } else {
                                self.locationId = '';
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
//                            self.error = response.data.message;
                            }
                        });
            },
            changedValueSearchFor: function () {
                self.roleForError = '';
            },
            onSearchRole(search, loading) {
                if (search.length >= 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },
            loadRoleFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    /*search: ''*/
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            if (self.categoryType != 'leadership') {
                                self.roleArr = response.data.content;
                            } else {
                                self.roleArr = [];
                                $.each(response.data.content, function (i) {
                                    if (response.data.content[i].value != 3) {
                                        self.roleArr.push(response.data.content[i]);
                                    }
                                });
                            }
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search,
                    'type': self.categoryType,
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                    }
                };
                self.showLoader();
                HTTP.get("getmaincategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changedCategoryFor: function () {

            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'search': search,
                    }

                };
                HTTP.get("getmaincategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/category/AddCategory.vue